import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoginMetadataState {
  featureFlagsList: string[];
  supportedLanguages: string[];
}

const initialState: LoginMetadataState = {
  featureFlagsList: ["initialValue"],
  supportedLanguages: [],
};

const loginMetadataReducer = createSlice({
  name: "loginMetadata",
  initialState,
  reducers: {
    setFeatureFlagList: (state, action: PayloadAction<string[]>) => {
      state.featureFlagsList = action.payload;
    },
    setSupportedLanguages: (state, action: PayloadAction<string[]>) => {
      state.supportedLanguages = action.payload;
    },
  },
});

export const { setFeatureFlagList, setSupportedLanguages } = loginMetadataReducer.actions;

export default loginMetadataReducer.reducer;
